/**
 * Shared utilities for game page components.
 */

export const API = process.env.REACT_APP_BACKEND_URL + "/api";

export const SPORT_STATS_CONFIG = {
  basketball: {
    primary: ["points", "rebounds", "assists"],
    labels: { points: "PTS", rebounds: "REB", assists: "AST" }
  },
  "girls-basketball": {
    primary: ["points", "rebounds", "assists"],
    labels: { points: "PTS", rebounds: "REB", assists: "AST" }
  },
  football: {
    primary: ["pass_yards", "rush_yards", "rec_yards"],
    labels: { pass_yards: "PASS", rush_yards: "RUSH", rec_yards: "REC" }
  },
  baseball: {
    primary: ["hits", "rbi", "runs"],
    labels: { hits: "H", rbi: "RBI", runs: "R" }
  },
  softball: {
    primary: ["hits", "rbi", "runs"],
    labels: { hits: "H", rbi: "RBI", runs: "R" }
  },
  soccer: {
    primary: ["goals", "assists", "shots"],
    labels: { goals: "G", assists: "A", shots: "SOG" }
  },
  volleyball: {
    primary: ["kills", "digs", "assists"],
    labels: { kills: "K", digs: "D", assists: "A" }
  },
  hockey: {
    primary: ["goals", "assists", "saves"],
    labels: { goals: "G", assists: "A", saves: "SV" }
  }
};

export const getStatConfig = (sport) => {
  const normalizedSport = sport?.toLowerCase().replace(/\s+/g, '-') || 'basketball';
  return SPORT_STATS_CONFIG[normalizedSport] || SPORT_STATS_CONFIG.basketball;
};

/**
 * Extract StatMoose game code from a stats_link URL or raw code.
 * Returns null if not a StatMoose link.
 */
export const extractStatMooseCode = (statsLink) => {
  if (!statsLink) return null;
  const link = statsLink.trim();
  if (link.includes("statmoose") || link.includes("stat-go-app")) {
    const cleaned = link.replace(/\/boxscore$/, "").replace(/\/$/, "");
    const segments = cleaned.split("/");
    const code = segments[segments.length - 1];
    if (code && code.length >= 6) return code;
  }
  if (/^[a-zA-Z0-9_-]{6,}$/.test(link)) return link;
  return null;
};

export const formatPlayerName = (name) => {
  if (!name || name.length <= 11) return name;
  const parts = name.trim().split(/\s+/);
  if (parts.length < 2) return name;
  return `${parts[0].charAt(0)}. ${parts.slice(1).join(' ')}`;
};
